var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-search-modal-no-results"},[(_vm.searchError)?_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('nav.enhanced_search.error', {
                i18nFallback: 'Oops, something went wrong.',
            }))+"\n    ")]):_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('nav.enhanced_search.no_installations_found', {
                i18nFallback: 'No installations found with',
            }))+"\n        "),_c('span',[_vm._v(_vm._s(_vm.searchTermOnFail))])]),_c('ul',[_c('li',[_vm._v("\n            "+_vm._s(_vm.$t('nav.enhanced_search.no_installations_hint1', {
                    i18nFallback: 'Make sure that all the words are spelled correctly',
                }))+"\n        ")]),_c('li',[_vm._v("\n            "+_vm._s(_vm.$t('nav.enhanced_search.no_installations_hint2', {
                    i18nFallback: 'Try a different query',
                }))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }